exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notify-send-section[data-v-bf3112f2] {\n  margin-bottom: 20px;\n}\n.notify-records-section h4[data-v-bf3112f2] {\n  margin: 0 0 15px 0;\n  color: #606266;\n}\n.record-filters[data-v-bf3112f2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 15px;\n}\n", ""]);

// exports
